import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/admin/supplier";

export default {
  getListOfCouriers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/couriers?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getLIstOfApprovedCourierSuppliers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/courier_approved?paginate=${pagination}&page=${pageNumber}&${filterQuery}&${sort}`)
  },
  createCourierSupplier(payload) {
    return Repository.post(`${resource}/couriers`, payload)
  },
  courierSupplierStatusChange(id, status) {
    return Repository.put(`${resource}/courier/${id}/${status}`)
  },
  getCourierSupplierDetails(id) {
    return Repository.get(`${resource}/couriers/${id}`)
  },
  updateCourierSupplierProfile(id, payload) {
    return Repository.put(`${resource}/couriers/${id}`, payload)
  },
  listOfCourierShipments(supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/courier_shipments?supplier_id=${supplier_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}&${sort}`)
  },
  listOfALlCourierShipments(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/courier_shipment_list?paginate=${pagination}&page=${pageNumber}&${filterQuery}&${sort}`)
  },
  shipmentStatusChange(id, status_name) {
    return Repository.put(`${resource}/courier_shipment/${id}/${status_name}`)
  },
  createProductItemCourierShipment(payload) {
    return Repository.post(`${resource}/courier_shipments`, payload)
  },
  updateProductItemCourierShipment(id, payload) {
    return Repository.put(`${resource}/courier_shipments/${id}`, payload)
  },
  getShipmentDetails(id) {
    return Repository.get(`${resource}/courier_shipments/${id}`)
  },
  listOfCourierServices(supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/courier_services?supplier_id=${supplier_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}&${sort}`)
  },
  createCourierService(payload) {
    return Repository.post(`${resource}/courier_services`, payload)
  },
  deleteCourierService(id) {
    return Repository.delete(`${resource}/courier_services/${id}`)
  },
  updateCourierService(id, payload) {
    return Repository.put(`${resource}/courier_services/${id}`, payload)
  },
  getDeliveryNotePdfData(id) {
    return Repository.get(`${resource}/courier-shipment/${id}/delivery-note-pdf-data`)
  },
  getDeliveryNotePdfDataFromSecret(code) {
    return Repository.get(`${resource}/courier-shipment/${code}/delivery-note-pdf`)
  },
  updateActualDeliveryDate(id, payload){
    return Repository.put(`${resource}/courier-shipment/${id}/update-delivery-dates`, payload)
  },

  // DOCUMENTS
  getShipmentDocuments(shipment_id) {
    return Repository.get(`${resource}/courier_shipment_documents?courier_shipment_id=${shipment_id}`)
  },
  createShipmentDocuments(payload) {
    return Repository.post(`${resource}/courier_shipment_documents`, payload)
  },
  deleteShipmentDoc(id) {
    return Repository.delete(`${resource}/courier_shipment_documents/${id}`)
  },
  sendShipmentDocument(id, payload) {
    return Repository.post(`${resource}/courier-shipment/${id}/send-delivery-note`, payload)
  },
  getDeliveryNotePdf(id){
    return Repository.get(`${resource}/courier-shipment/${id}/delivery-note-pdf-doc`,{
      responseType: 'blob'
    })
  },
};
